<template>
  <confirm-auth
    v-if="showConfirm"
    :details="confirmDetails"
    :error="error"
    :confirm-state="forgotPassConfirm"
    @cancel-confirm="cancelConfirm"
    @submit-confirm="onConfirmSubmitted"
  >
    <loading-spinner v-show="loading" />
  </confirm-auth>
  <div
    v-else
    class="auth-screen"
  >
    <loading-spinner v-show="loading" />
    <h2 class="mb-4">
      Reset Password
    </h2>
    <b-container class="auth-block has-border">
      <b-row>
        <b-col>
          <label for="user-emailid">Email</label>
          <b-form-input
            id="user-emailid"
            v-model.trim="userName"
            type="text"
            @keyup.13="onSubmitResetForm"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-end flex-no-wrap ml-3 mt-3 ">
          <div
            v-if="error"
            class="mr-4 alert alert-danger fade show"
            role="alert"
          >
            {{ error }}
          </div>
          <b-button
            class="ml-2 mr-2"
            title="Cancel"
            :disabled="loading"
            @click="onCancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            title="Reset Password"
            :disabled="userName === ''"
            @click="onSubmitResetForm"
            @keyup.13="onSubmitResetForm"
          >
            Reset Password
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <div class="mt-4 d-flex">
      Enter the email associated with this account. <br>
      An authentication token will be sent to this email to reset the
      password.
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import ConfirmAuth from './ConfirmAuth'
import { isValidEmail } from '@/_globals/field-validations'
import LoadingSpinner from '@/components/UIComponents/LoadingSpinner'

export default {
  name: 'ForgotPassword',
  components: {
    ConfirmAuth,
    LoadingSpinner
  },
  data: function () {
    return {
      authData: {},
      authState: 'forgotPassword',
      showConfirm: false,
      confirmDetails: {},
      error: '',
      userName: '',
      loading: false,
      forgotPassConfirm: 'forgotPassConfirm'
    }
  },
  methods: {
    async onConfirmSubmitted(token, password) {
      try {
        this.loading = true
        await Auth.forgotPasswordSubmit(
          this.userName,
          token,
          password
        )
        this.loading = false
        // Have to notify successful password changed
        // Change the auth state to SignIn again
        this.$store.dispatch('auth/setAuthViewState', 'signIn')
        this.$notify({
          group: 'ConfigTool',
          title: 'Password Updated',
          text: 'Password successfully changed',
          type: 'success'
        })
      } catch (errorResponse) {
        let response = ''
        // AWS is not very consistent with what they are sending back
        if (
          errorResponse.code &&
          errorResponse.code === 'InvalidParameterException'
        ) {
          response =
            'Invalid Parameter. Either token was incorrect or password did not satisfy restraints'
        } else {
          response =
            typeof errorResponse === 'string'
              ? errorResponse
              : errorResponse.message
        }
        this.error = response
        this.loading = false
        this.showConfirm = true
      }
    },
    onCancel() {
      this.$store.dispatch('auth/setAuthViewState', 'signIn')
    },
    async onSubmitResetForm() {
      this.error = ''
      this.loading = true
      const invalid = isValidEmail(this.userName) !== undefined
      if (invalid) {
        this.error = 'Invalid email'
        this.loading = false
      } else {
        try {
          this.error = ''
          this.loading = true
          const response = await Auth.forgotPassword(this.userName)
          this.confirmDetails = response.CodeDeliveryDetails
          this.showConfirm = true
          this.loading = false
        } catch (err) {
          console.error('There is an error caught', err)
          const error = typeof err === 'string' ? err : err.message
          this.error = error
          this.loading = false
        }
      }
    },
    cancelConfirm() {
      this.showConfirm = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
  @import '~@/assets/styles/auth.scss';
</style>

